// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TaskAssignPage.css */
.task-assign-page {
    padding-left: 50px;
    padding-right: 50px;
    padding-top:20px; 
    font-family: Arial, sans-serif;
  }
  
  .bg-white {
    background-color: #ffffff;
  }
  
  .rounded-lg {
    border-radius: 0.75rem;
  }
  
  .shadow-md {
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .text-2xl {
    font-size: 1.5rem;
  }
  
  .font-bold {
    font-weight: 700;
  }
  
  .mb-6 {
    margin-bottom: 1.5rem;
  }
  
  .mb-4 {
    margin-bottom: 1rem;
  }
  
  .text-gray-700 {
    color: #4a5568;
  }
  
  .font-medium {
    font-weight: 500;
  }
  
  .hover\\:bg-gray-100:hover {
    background-color: #f7fafc;
  }
  
  .table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .table th,
  .table td {
    border: 1px solid #e2e8f0;
    padding: 0.75rem;
    text-align: left;
  }
  
  .table th {
    background-color: #edf2f7;
    font-weight: bold;
  }
  
  .px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  
  .py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  
  .hover\\:bg-gray-100:hover {
    background-color: #f7fafc;
  }
  
  .text-green-600 {
    color: #38a169;
  }
  
  .font-semibold {
    font-weight: 600;
  }
  
  .mt-4 {
    margin-top: 1rem;
  }
  
  .text-center {
    text-align: center;
  }
  
  .bg-blue-500 {
    background-color: #4299e1;
  }
  
  .bg-blue-700 {
    background-color: #2b6cb0;
  }
  
  .bg-green-500 {
    background-color: #48bb78;
  }
  
  .bg-green-700 {
    background-color: #2f855a;
  }
  
  .text-white {
    color: #ffffff;
  }
  
  
  
  .rounded-lg {
    border-radius: 0.5rem;
  }
  
  .hover\\:bg-blue-700:hover {
    background-color: #2b6cb0;
  }
  
  .hover\\:bg-green-700:hover {
    background-color: #2f855a;
  }
  
  .border-collapse {
    border-collapse: collapse;
  }
  
  .border {
    border-width: 1px;
    border-color: #e2e8f0;
  }
  
  .border-gray-300 {
    border-color: #d2d6dc;
  }
  
  .text-xl {
    font-size: 1.25rem;
  }
  
  .text-center {
    text-align: center;
  }
  
  .text-green-600 {
    color: #38a169;
  }
  
  .font-medium {
    font-weight: 500;
  }
  
  /*.mt-4 {
    margin-top: 1rem;
  }
   */`, "",{"version":3,"sources":["webpack://./src/pages/TaskAssignPage.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;IAEE,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;;;EAIA;IACE,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;IAGE","sourcesContent":["/* TaskAssignPage.css */\r\n.task-assign-page {\r\n    padding-left: 50px;\r\n    padding-right: 50px;\r\n    padding-top:20px; \r\n    font-family: Arial, sans-serif;\r\n  }\r\n  \r\n  .bg-white {\r\n    background-color: #ffffff;\r\n  }\r\n  \r\n  .rounded-lg {\r\n    border-radius: 0.75rem;\r\n  }\r\n  \r\n  .shadow-md {\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .text-2xl {\r\n    font-size: 1.5rem;\r\n  }\r\n  \r\n  .font-bold {\r\n    font-weight: 700;\r\n  }\r\n  \r\n  .mb-6 {\r\n    margin-bottom: 1.5rem;\r\n  }\r\n  \r\n  .mb-4 {\r\n    margin-bottom: 1rem;\r\n  }\r\n  \r\n  .text-gray-700 {\r\n    color: #4a5568;\r\n  }\r\n  \r\n  .font-medium {\r\n    font-weight: 500;\r\n  }\r\n  \r\n  .hover\\:bg-gray-100:hover {\r\n    background-color: #f7fafc;\r\n  }\r\n  \r\n  .table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n  }\r\n  \r\n  .table th,\r\n  .table td {\r\n    border: 1px solid #e2e8f0;\r\n    padding: 0.75rem;\r\n    text-align: left;\r\n  }\r\n  \r\n  .table th {\r\n    background-color: #edf2f7;\r\n    font-weight: bold;\r\n  }\r\n  \r\n  .px-4 {\r\n    padding-left: 1rem;\r\n    padding-right: 1rem;\r\n  }\r\n  \r\n  .py-2 {\r\n    padding-top: 0.5rem;\r\n    padding-bottom: 0.5rem;\r\n  }\r\n  \r\n  .hover\\:bg-gray-100:hover {\r\n    background-color: #f7fafc;\r\n  }\r\n  \r\n  .text-green-600 {\r\n    color: #38a169;\r\n  }\r\n  \r\n  .font-semibold {\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .mt-4 {\r\n    margin-top: 1rem;\r\n  }\r\n  \r\n  .text-center {\r\n    text-align: center;\r\n  }\r\n  \r\n  .bg-blue-500 {\r\n    background-color: #4299e1;\r\n  }\r\n  \r\n  .bg-blue-700 {\r\n    background-color: #2b6cb0;\r\n  }\r\n  \r\n  .bg-green-500 {\r\n    background-color: #48bb78;\r\n  }\r\n  \r\n  .bg-green-700 {\r\n    background-color: #2f855a;\r\n  }\r\n  \r\n  .text-white {\r\n    color: #ffffff;\r\n  }\r\n  \r\n  \r\n  \r\n  .rounded-lg {\r\n    border-radius: 0.5rem;\r\n  }\r\n  \r\n  .hover\\:bg-blue-700:hover {\r\n    background-color: #2b6cb0;\r\n  }\r\n  \r\n  .hover\\:bg-green-700:hover {\r\n    background-color: #2f855a;\r\n  }\r\n  \r\n  .border-collapse {\r\n    border-collapse: collapse;\r\n  }\r\n  \r\n  .border {\r\n    border-width: 1px;\r\n    border-color: #e2e8f0;\r\n  }\r\n  \r\n  .border-gray-300 {\r\n    border-color: #d2d6dc;\r\n  }\r\n  \r\n  .text-xl {\r\n    font-size: 1.25rem;\r\n  }\r\n  \r\n  .text-center {\r\n    text-align: center;\r\n  }\r\n  \r\n  .text-green-600 {\r\n    color: #38a169;\r\n  }\r\n  \r\n  .font-medium {\r\n    font-weight: 500;\r\n  }\r\n  \r\n  /*.mt-4 {\r\n    margin-top: 1rem;\r\n  }\r\n   */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
